var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettingMenu03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FAF5F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#A97752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 20.68H11.7294C11.2778 20.68 10.9115 20.3137 10.9115 19.8621V10.8179C10.9115 10.3663 11.2778 10 11.7294 10H18.7071C19.1587 10 19.525 10.3663 19.525 10.8179V19.8621C19.525 20.3158 19.1587 20.68 18.7071 20.68Z",
    fill: "#A97752",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8572 12.9322H17.9412",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9413 15.0757V17.5501C17.9413 17.7436 17.7852 17.8997 17.5917 17.8997H13.2111C13.0175 17.8997 12.8615 17.7436 12.8615 17.5501V15.0757C12.8615 14.8822 13.0175 14.7261 13.2111 14.7261H17.5917C17.7832 14.7261 17.9413 14.8822 17.9413 15.0757Z",
    stroke: "#FAF5F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4026 12.4598H10.4849C10.2164 12.4598 10 12.2684 10 12.0332C10 11.798 10.2164 11.6087 10.4849 11.6087H11.4026C11.6711 11.6087 11.8875 11.8001 11.8875 12.0353C11.8875 12.2704 11.6711 12.4598 11.4026 12.4598Z",
    fill: "#FAF5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4026 19.3169H10.4849C10.2164 19.3169 10 19.1254 10 18.8903C10 18.6551 10.2164 18.4658 10.4849 18.4658H11.4026C11.6711 18.4658 11.8875 18.6572 11.8875 18.8924C11.8875 19.1275 11.6711 19.3169 11.4026 19.3169Z",
    fill: "#FAF5F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingMenu03);
export default __webpack_public_path__ + "static/media/icon-setting-menu03.b9b14a0de6432bf27edbf406a8997729.svg";
export { ForwardRef as ReactComponent };